module.exports = __webpack_public_path__ + "static/Heroku_Balloon-f0e7dd468a3c5bdcb90d058f5d174b1d.png";